<template>
<div class="side animate-box">
    <p v-if="id_design == '341'"><strong>Contact A Coach</strong></p>
    <p v-else-if="this.$store.state.companyData['id_country']+this.$store.state.companyData['id_language'] == '003001'"><strong>Contact A Counselor</strong></p>
    <p v-else-if="this.$store.state.companyData['id_company'] == '100679170'"><strong>Contact A Counselor</strong><br /><br /><sup><em>By contacting Aetna, you agree that any information you share will be kept confidential and will not be shared with McKesson and that your information will be stored in a secure location, which may be outside your home country.</em></sup></p>
    <p v-else><strong v-html="lang_detail['cntr114']"></strong></p>
    
    <div v-if="returnmsg==''">
        <p> <span v-html="lang_detail['requiredDescription']"></span> (<span class="required_indicator">*</span>)</p>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="company" v-html="companyLabel"></label>
                <!--<select name="company" id="company" v-model="company" class="form-control" ref="company" aria-label="company">
                    <option v-for="(value, key) in comp_list" :value="key+'_'+value" :key="key">{{ value }}</option>
                </select>  -->
                <!-- <input type="text" name="shwcompany" id="shwcompany" autocomplete="off" class="form-control" @keyup="myFunction()" ref="company" aria-label="company" />
				<input type="hidden" name="company" id="company" class="ctrl" v-model="company" /> 
                <ul id="myUL" style="display:none;height: 100px; overflow: auto;">
                    <li v-for="(value, key) in comp_list" :key="key"><a href="#" @click="filCompValue(key+'_'+value)">{{ value }}</a></li>
                </ul>
                <ul id="err" style="display:none;">
                    <li>Not found</li>
                </ul> -->
                <input type="text" name="shwcompany" id="shwcompany" autocomplete="off" class="form-control" v-model="shwcompany" ref="company" aria-label="company" aria-required="true" />
				<input type="hidden" name="company" id="company" class="ctrl" v-model="company" />
            </div>
            <span id="company_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="fname" v-html="lang_detail['first_name']"></label>
                <input type="text" id="fname" class="form-control" v-model="fname" ref="fname" aria-label="First Name" maxlength = "200" aria-required="true">
            </div>
            <span id="fname_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="lname" v-html="lang_detail['last_name']"></label>
                <input type="text" id="lname" class="form-control" v-model="lname" ref="lname" aria-label="Last Name" maxlength = "200" aria-required="true">
            </div>
            <span id="lname_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="gender" v-html="lang_detail['gender']"></label>
                <select name="gender" id="gender" v-model="gender" class="form-control" ref="gender" aria-label="Gender" aria-required="true">
                    <option v-html="lang_detail['male']" ></option>
                    <option v-html="lang_detail['female']"></option>
                    <option v-html="lang_detail['undisclosed']"></option>
                    <option v-html="lang_detail['transgender']"></option>
                    <option v-html="lang_detail['nonbinary']"></option>
                    <option v-html="lang_detail['nonconforming']"></option>
                </select>            
            </div>
            <span id="gender_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="dob" v-html="lang_detail['date_birth']"></label>
                <input type="date" id="dob" class="form-control" v-model="dob" ref='dob' aria-label="Date of Birth" :max="todayDate" :data-date="defaultDateFormat" @change="setDate" aria-required="true">
            </div>
            <span id="dob_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="phone" v-html="lang_detail['phone']+lang_detail['phoneformat']"></label>                
                <vue-tel-input v-model="phone" v-bind="bindProps" @input="emitToTelinput" ref="phone" maxlength = "46">
                    <template v-slot:arrow-icon>
                        <span> ▼ </span>
                    </template>
                </vue-tel-input>
            </div>
            <span id="phone_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="country_list" v-html="lang_detail['home_country']" ref="country"></label>
                <multiselect name="country" id="country_list" v-model="country" :options="options" placeholder="" label="name"   aria-label="Country"></multiselect>
                <!--<select name="country" v-model="country" id="country_list" class="form-control" ref="country" aria-label="Country">
                    <option value=""></option>
                    <option value="US_United States">United States</option>
                    <option value="GB_United Kingdom">United Kingdom</option>
                    <option value="CA_Canada">Canada</option>
                    <option value="AT_Austria">Austria</option>
                    <option value="BR_Brazil">Brazil</option>
                    <option value="DE_Germany">Germany</option>
                    <option value="AF_Afghanistan">Afghanistan</option>
                    <option value="AL_Albania">Albania</option>
                    <option value="AQ_Antarctica">Antarctica</option>
                    <option value="DZ_Algeria">Algeria</option>
                    <option value="AS_American Samoa">American Samoa</option>
                    <option value="AD_Andorra">Andorra</option>
                    <option value="AO_Angola">Angola</option>
                    <option value="AG_Antigua and Barbuda">Antigua and Barbuda</option>
                    <option value="AZ_Azerbaijan">Azerbaijan</option>
                    <option value="AR_Argentina">Argentina</option>
                    <option value="AU_Australia">Australia</option>
                    <option value="BS_Bahamas">Bahamas</option>
                    <option value="BH_Bahrain">Bahrain</option>
                    <option value="BD_Bangladesh">Bangladesh</option>
                    <option value="AM_Armenia">Armenia</option>
                    <option value="BB_Barbados">Barbados</option>
                    <option value="BE_Belgium">Belgium</option>
                    <option value="BM_Bermuda">Bermuda</option>
                    <option value="BT_Bhutan">Bhutan</option>
                    <option value="BO_Bolivia">Bolivia</option>
                    <option value="BA_Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                    <option value="BW_Botswana">Botswana</option>
                    <option value="BV_Bouvet Island">Bouvet Island</option>
                    <option value="BZ_Belize">Belize</option>
                    <option value="IO_British Indian Ocean Territory">British Indian Ocean Territory</option>
                    <option value="SB_Solomon Islands">Solomon Islands</option>
                    <option value="VG_Virgin Islands (British)">Virgin Islands (British)</option>
                    <option value="BN_Brunei Darussalam">Brunei Darussalam</option>
                    <option value="BG_Bulgaria">Bulgaria</option>
                    <option value="MM_Myanmar">Myanmar</option>
                    <option value="BI_Burundi">Burundi</option>
                    <option value="BY_Belarus">Belarus</option>
                    <option value="KH_Cambodia">Cambodia</option>
                    <option value="CM_Cameroon">Cameroon</option>
                    <option value="CV_Cape Verde">Cape Verde</option>
                    <option value="KY_Cayman Islands">Cayman Islands</option>
                    <option value="CF_Central African Republic">Central African Republic</option>
                    <option value="LK_Sri Lanka">Sri Lanka</option>
                    <option value="TD_Chad">Chad</option>
                    <option value="CL_Chile">Chile</option>
                    <option value="CN_China">China</option>
                    <option value="TW_Taiwan, Province of China">Taiwan, Province of China</option>
                    <option value="CX_Christmas island">Christmas island</option>
                    <option value="CC_Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                    <option value="CO_Colombia">Colombia</option>
                    <option value="KM_Comoros">Comoros</option>
                    <option value="YT_Mayotte">Mayotte</option>
                    <option value="CG_Congo">Congo</option>
                    <option value="CD_Congo, The Democratic Republic of the">Congo, The Democratic Republic of the</option>
                    <option value="CK_Cook Islands">Cook Islands</option>
                    <option value="CR_Costa Rica">Costa Rica</option>
                    <option value="HR_Croatia">Croatia</option>
                    <option value="CU_Cuba">Cuba</option>
                    <option value="CY_Cyprus">Cyprus</option>
                    <option value="CZ_Czech Republic">Czech Republic</option>
                    <option value="BJ_Benin">Benin</option>
                    <option value="DK_Denmark">Denmark</option>
                    <option value="DM_Dominica">Dominica</option>
                    <option value="DO_Dominican Republic">Dominican Republic</option>
                    <option value="EC_Ecuador">Ecuador</option>
                    <option value="SV_El Salvador">El Salvador</option>
                    <option value="GQ_Equatorial Guinea">Equatorial Guinea</option>
                    <option value="ET_Ethiopia">Ethiopia</option>
                    <option value="ER_Eritrea">Eritrea</option>
                    <option value="EE_Estonia">Estonia</option>
                    <option value="FO_Faroe Islands">Faroe Islands</option>
                    <option value="FK_Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                    <option value="GS_South Georgia and the South Sandwich Islands">South Georgia and the South Sandwich Islands</option>
                    <option value="FJ_Fiji">Fiji</option>
                    <option value="FI_Finland">Finland</option>
                    <option value="AX_Aland Islands">Aland Islands</option>
                    <option value="FR_France">France</option>
                    <option value="GF_French Guiana">French Guiana</option>
                    <option value="PF_French Polynesia">French Polynesia</option>
                    <option value="TF_French Southern Territories">French Southern Territories</option>
                    <option value="DJ_Djibouti">Djibouti</option>
                    <option value="GA_Gabon">Gabon</option>
                    <option value="GE_Georgia">Georgia</option>
                    <option value="GM_Gambia">Gambia</option>
                    <option value="PS_Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                    <option value="GH_Ghana">Ghana</option>
                    <option value="GI_Gibraltar">Gibraltar</option>
                    <option value="KI_Kiribati">Kiribati</option>
                    <option value="GR_Greece">Greece</option>
                    <option value="GL_Greenland">Greenland</option>
                    <option value="GD_Grenada">Grenada</option>
                    <option value="GP_Guadeloupe">Guadeloupe</option>
                    <option value="GU_Guam">Guam</option>
                    <option value="GT_Guatemala">Guatemala</option>
                    <option value="GN_Guinea">Guinea</option>
                    <option value="GY_Guyana">Guyana</option>
                    <option value="HT_Haiti">Haiti</option>
                    <option value="HM_Heard Island and McDonald Islands">Heard Island and McDonald Islands</option>
                    <option value="VA_Vatican City State (Holy See)">Vatican City State (Holy See)</option>
                    <option value="HN_Honduras">Honduras</option>
                    <option value="HK_Hong Kong">Hong Kong</option>
                    <option value="HU_Hungary">Hungary</option>
                    <option value="IS_Iceland">Iceland</option>
                    <option value="IN_India">India</option>
                    <option value="ID_Indonesia">Indonesia</option>
                    <option value="IR_Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                    <option value="IQ_Iraq">Iraq</option>
                    <option value="IE_Ireland">Ireland</option>
                    <option value="IL_Israel">Israel</option>
                    <option value="IT_Italy">Italy</option>
                    <option value="CI_Cote D'Ivoire">Cote D'Ivoire</option>
                    <option value="JM_Jamaica">Jamaica</option>
                    <option value="JP_Japan">Japan</option>
                    <option value="KZ_Kazakhstan">Kazakhstan</option>
                    <option value="JO_Jordan">Jordan</option>
                    <option value="KE_Kenya">Kenya</option>
                    <option value="KP_Korea, Democratic People's Republic of">Korea, Democratic People's Republic of</option>
                    <option value="KR_Korea">Korea</option>
                    <option value="KW_Kuwait">Kuwait</option>
                    <option value="KG_Kyrgyzstan">Kyrgyzstan</option>
                    <option value="LA_Lao people's democratic republic">Lao people's democratic republic</option>
                    <option value="LB_Lebanon">Lebanon</option>
                    <option value="LS_Lesotho">Lesotho</option>
                    <option value="LV_Latvia">Latvia</option>
                    <option value="LR_Liberia">Liberia</option>
                    <option value="LY_Libya">Libya</option>
                    <option value="LI_Liechtenstein">Liechtenstein</option>
                    <option value="LT_Lithuania">Lithuania</option>
                    <option value="LU_Luxembourg">Luxembourg</option>
                    <option value="MO_Macao">Macao</option>
                    <option value="MG_Madagascar">Madagascar</option>
                    <option value="MW_Malawi">Malawi</option>
                    <option value="MY_Malaysia">Malaysia</option>
                    <option value="MV_Maldives">Maldives</option>
                    <option value="ML_Mali">Mali</option>
                    <option value="MT_Malta">Malta</option>
                    <option value="MQ_Martinique">Martinique</option>
                    <option value="MR_Mauritania">Mauritania</option>
                    <option value="MU_Mauritius">Mauritius</option>
                    <option value="MX_Mexico">Mexico</option>
                    <option value="MC_Monaco">Monaco</option>
                    <option value="MN_Mongolia">Mongolia</option>
                    <option value="MD_Moldova, Republic of">Moldova, Republic of</option>
                    <option value="ME_Montenegro">Montenegro</option>
                    <option value="MS_Montserrat">Montserrat</option>
                    <option value="MA_Morocco">Morocco</option>
                    <option value="MZ_Mozambique">Mozambique</option>
                    <option value="OM_Oman">Oman</option>
                    <option value="NA_Namibia">Namibia</option>
                    <option value="NR_Nauru">Nauru</option>
                    <option value="NP_Nepal">Nepal</option>
                    <option value="NL_Netherlands">Netherlands</option>
                    <option value="AN_Netherlands Antilles">Netherlands Antilles</option>
                    <option value="AW_Aruba">Aruba</option>
                    <option value="NC_New Caledonia">New Caledonia</option>
                    <option value="VU_Vanuatu">Vanuatu</option>
                    <option value="NZ_New Zealand">New Zealand</option>
                    <option value="NI_Nicaragua">Nicaragua</option>
                    <option value="NE_Niger">Niger</option>
                    <option value="NG_Nigeria">Nigeria</option>
                    <option value="NU_Niue">Niue</option>
                    <option value="NF_Norfolk Island">Norfolk Island</option>
                    <option value="NO_Norway">Norway</option>
                    <option value="MP_Northern Mariana Islands">Northern Mariana Islands</option>
                    <option value="UM_United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                    <option value="FM_Micronesia, Federated States of">Micronesia, Federated States of</option>
                    <option value="MH_Marshall Islands">Marshall Islands</option>
                    <option value="PW_Palau">Palau</option>
                    <option value="PK_Pakistan">Pakistan</option>
                    <option value="PA_Panama">Panama</option>
                    <option value="PG_Papua New Guinea">Papua New Guinea</option>
                    <option value="PY_Paraguay">Paraguay</option>
                    <option value="PE_Peru">Peru</option>
                    <option value="PH_Philippines">Philippines</option>
                    <option value="PN_Pitcairn">Pitcairn</option>
                    <option value="PL_Poland">Poland</option>
                    <option value="PT_Portugal">Portugal</option>
                    <option value="GW_Guinea-bissau">Guinea-bissau</option>
                    <option value="TL_Timor-leste">Timor-leste</option>
                    <option value="PR_Puerto Rico">Puerto Rico</option>
                    <option value="QA_Qatar">Qatar</option>
                    <option value="RE_Reunion">Reunion</option>
                    <option value="RO_Romania">Romania</option>
                    <option value="RU_Russian Federation">Russian Federation</option>
                    <option value="RW_Rwanda">Rwanda</option>
                    <option value="BL_Saint Barthelemy">Saint Barthelemy</option>
                    <option value="SH_Saint Helena">Saint Helena</option>
                    <option value="KN_Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                    <option value="AI_Anguilla">Anguilla</option>
                    <option value="LC_Saint Lucia">Saint Lucia</option>
                    <option value="MT_Saint Martin (French)">Saint Martin (French)</option>
                    <option value="PM_Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                    <option value="VC_Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                    <option value="SM_San Marino">San Marino</option>
                    <option value="ST_Sao Tome and Principe">Sao Tome and Principe</option>
                    <option value="SA_Saudi Arabia">Saudi Arabia</option>
                    <option value="SN_Senegal">Senegal</option>
                    <option value="RS_Serbia">Serbia</option>
                    <option value="SC_Seychelles">Seychelles</option>
                    <option value="SL_Sierra Leone">Sierra Leone</option>
                    <option value="SG_Singapore">Singapore</option>
                    <option value="SK_Slovakia">Slovakia</option>
                    <option value="VN_Vietnam">Vietnam</option>
                    <option value="SI_Slovenia">Slovenia</option>
                    <option value="SO_Somalia">Somalia</option>
                    <option value="ZA_South Africa">South Africa</option>
                    <option value="ZW_Zimbabwe">Zimbabwe</option>
                    <option value="ES_Spain">Spain</option>
                    <option value="EH_Western Sahara">Western Sahara</option>
                    <option value="SD_Sudan">Sudan</option>
                    <option value="SR_Suriname">Suriname</option>
                    <option value="SJ_Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                    <option value="SZ_Swaziland">Swaziland</option>
                    <option value="SE_Sweden">Sweden</option>
                    <option value="CH_Switzerland">Switzerland</option>
                    <option value="SY_Syrian Arab Republic">Syrian Arab Republic</option>
                    <option value="TJ_Tajikistan">Tajikistan</option>
                    <option value="TH_Thailand">Thailand</option>
                    <option value="TG_Togo">Togo</option>
                    <option value="TK_Tokelau">Tokelau</option>
                    <option value="TO_Tonga">Tonga</option>
                    <option value="TT_Trinidad and Tobago">Trinidad and Tobago</option>
                    <option value="AE_United Arab Emirates">United Arab Emirates</option>
                    <option value="TN_Tunisia">Tunisia</option>
                    <option value="TR_Turkey">Turkey</option>
                    <option value="TM_Turkmenistan">Turkmenistan</option>
                    <option value="TC_Turks and Caicos Islands">Turks and Caicos Islands</option>
                    <option value="TV_Tuvalu">Tuvalu</option>
                    <option value="UG_Uganda">Uganda</option>
                    <option value="UA_Ukraine">Ukraine</option>
                    <option value="MK_Macedonia, The Former Yugoslav Republic of">Macedonia, The Former Yugoslav Republic of</option>
                    <option value="EG_Egypt">Egypt</option>
                    <option value="GG_Guernsey">Guernsey</option>
                    <option value="JE_Jersey">Jersey</option>
                    <option value="IM_Isle of man">Isle of man</option>
                    <option value="TZ_Tanzania, United Republic of">Tanzania, United Republic of</option>
                    <option value="VI_Virgin islands (U.S.)">Virgin islands (U.S.)</option>
                    <option value="BF_Burkina Faso">Burkina Faso</option>
                    <option value="UY_Uruguay">Uruguay</option>
                    <option value="UZ_Uzbekistan">Uzbekistan</option>
                    <option value="VE_Venezuela">Venezuela</option>
                    <option value="WF_Wallis and Futuna">Wallis and Futuna</option>
                    <option value="WS_Samoa">Samoa</option>
                    <option value="YE_Yemen">Yemen</option>
                    <option value="YU_Yugoslavia">Yugoslavia</option>
                    <option value="ZM_Zambia">Zambia</option>
                    <option value="KV_Kosovo">Kosovo</option>
                    <option value="SS_South Sudan">South Sudan</option>
                    <option value="0_Global">Global</option>
                    <option value="0_Channel Islands">Channel Islands</option>
                    <option value="0_Azores">Azores</option>
                    <option value="0_Diego Garcia">Diego Garcia</option>
                    <option value="IC_Ivory Coast">Ivory Coast</option>
                    <option value="0_Unknown">Unknown</option>
                    <option value="CW_Curaçao">Curaçao</option>
				</select>-->
            </div>
            <span id="country_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="hemaill" v-html="lang_detail['email_home']"></label>
                <input type="text" id="hemaill" class="form-control" v-model="hemail" ref='hemail' aria-label="Home Email" maxlength = "200" aria-required="true">
            </div>
            <span id="hemail_validation_error"  role="alert"></span>
        </div>
        <!--<div class="row form-group">
            <div class="col-md-12">
                <label for="wemaill" v-html="lang_detail['email_work']"></label>
                <input type="text" id="wemaill" class="form-control" v-model="wemail" ref='wemail' aria-label="Work Email">
            </div>
        </div>-->
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="bestTime" v-html="lang_detail['phoneTimes']"></label>
                <select name="bestTime" id="bestTime" v-model="bestTime" class="form-control" ref="bestTime" aria-label="preferred time for contact" aria-required="true">
                    <option v-html="lang_detail['anytime']" selected></option>
                    <option v-html="lang_detail['morning']"></option>
                    <option v-html="lang_detail['afternoon']"></option>
                    <option v-html="lang_detail['evening']"></option>
                </select>            
            </div>
            <span id="bestTime_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="message" v-html="lang_detail['reasonContact']"></label>
                <select name="message" id="message1" v-model="message" class="form-control" ref="message" aria-label="Reason for inquiry" aria-required="true">
                    <option v-for="(value, key) in service_list" :value="key" :key="key">{{ value }}</option>
                    
                </select>            
            </div>
            <span id="message_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <input type="checkbox" name="fterms" id="fterms"  v-model="fterms" ref="fterms" aria-label="Accept terms and conditions" aria-required="true">&nbsp;<span v-html="terms_check"></span>
            </div>
            <span id="fterms_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <p></p>
        </div>
        <div class="row form-group hhcap">
            <vue-hcaptcha :sitekey="$store.state.HC_SITE_KEY"  @verify="onVerify" @expired="onExpire" @error="onError"></vue-hcaptcha>
            <span id="hccaptcha_validation_error" role="alert"></span>
        </div>    
        <div class="form-group">
            <button type="button" :disabled="disablefdbtn" id="subButton" class="btn submit btn-primary" @click="sendForm()" v-html="lang_detail['submit']"></button>
        </div>
    </div>
    <p v-else v-html="returnmsg" role="alert"></p>
</div>    
</template>
<script>
import axios from 'axios';
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css';
import {UCMS_API_URL,UCMS_AUTHORIZATION,UCMS_WPOSUBSCRIBER} from '@/constants/general_constants';
import moment from 'moment';
import Multiselect from 'vue-multiselect'
export default {
    name: 'ContactCounselor',
    data(){
        return{
            verified: false,
            expired: false,
            token: null,
            eKey: null,
            error: null,
            disablefdbtn:false,
            terms_check:'',
            todayDate:'',
            gender:'',
            defaultDateFormat: 'MM/DD/YYYY',
            lang_detail:[],
            service_list:'',
            comp_list:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            languageData:this.$store.state.languageData,
            fterms:'',
            message:'',
            hemail:'',
            fname:'',
            lname:'',
            dob:'',
            company:'',
            shwcompany:'',
            companyLabel:'',
            reasonListAry:[],
            europeanCountryAry:['019','015','039','040','042','044','043','047','049','050','080','053'],
            returnmsg:'',        
            phone:'',
            country:'',
            wemail:'',
            bestTime:'',
            id_design:localStorage.id_design,
            phoneMsg:'',
            comp_detail:'',
            phonenumwithcode: '',
            bindProps: {
                mode: "international",
                disabledFetchingCountry: true,
                preferredCountries: [ 'us', 'gb' ],
                placeholder: "",
                name: "phone",
                //enabledCountryCode: true,
                validCharactersOnly: true,
                dropdownOptions: {
                    showDialCodeInSelection: true,
                    showFlags: true,
                    showDialCodeInList: true,
                },
                inputOptions: {
                    placeholder: "",
                    name: "phone",
                    id: "phone",
                    showDialCode: false,
                    maxlength: "46",
                } 
                /*  defaultCountry: "FR",
                    disabledFetchingCountry: false,
                    disabled: false,
                    disabledFormatting: false,
                    placeholder: "Enter a phone number",
                    required: false,
                    enabledCountryCode: true,
                    enabledFlags: true,
                    preferredCountries: ["AU", "BR"],
                    onlyCountries: [],
                    ignoredCountries: [],
                    autocomplete: "off",
                    name: "telephone",
                    maxLen: 25,
                    wrapperClasses: "",
                    inputClasses: "",
                    dropdownOptions: {
                    disabledDialCode: false
                    },
                    inputOptions: {
                    showDialCode: false
                    } */
            },
            options: [
                { name: 'United States', language: 'US_United States' },
                { name: 'United Kingdom', language: 'GB_United Kingdom' },
                { name: 'Canada', language: 'CA_Canada' },
                { name: 'Austria', language: 'AT_Austria' },
                { name: 'Brazil', language: 'BR_Brazil' },
                { name: 'Afghanistan', language: 'AF_Afghanistan' },
                { name: 'Albania', language: 'AL_Albania' },
                { name: 'Antarctica', language: 'AQ_Antarctica' },
                { name: 'Algeria', language: 'DZ_Algeria' },
                { name: 'American Samoa', language: 'AS_American Samoa' },
                { name: 'Andorra', language: 'AD_Andorra' },
                { name: 'Angola', language: 'AO_Angola' },
                { name: 'Antigua and Barbuda', language: 'AG_Antigua and Barbuda' },
                { name: 'Azerbaijan', language: 'AZ_Azerbaijan' },
                { name: 'Argentina', language: 'AR_Argentina' },
                { name: 'Australia', language: 'AU_Australia' },
                { name: 'Bahamas', language: 'BS_Bahamas' },
                { name: 'Bahrain', language: 'BH_Bahrain' },
                { name: 'Bangladesh', language: 'BD_Bangladesh' },
                { name: 'Armenia', language: 'AM_Armenia' },
                { name: 'Barbados', language: 'BB_Barbados' },
                { name: 'Belgium', language: 'BE_Belgium' },
                { name: 'Bermuda', language: 'BM_Bermuda' },
                { name: 'Bhutan', language: 'BT_Bhutan' },
                { name: 'Bolivia', language: 'BO_Bolivia' },
                { name: 'Bosnia and Herzegovina', language: 'BA_Bosnia and Herzegovina' },
                { name: 'Botswana', language: 'BW_Botswana' },
                { name: 'Bouvet Island', language: 'BV_Bouvet Island' },
                { name: 'Belize', language: 'BZ_Belize' },
                { name: 'British Indian Ocean Territory', language: 'IO_British Indian Ocean Territory' },
                { name: 'Solomon Islands', language: 'SB_Solomon Islands' },
                { name: 'Virgin Islands (British)', language: 'VG_Virgin Islands (British)' },
                { name: 'Brunei Darussalam', language: 'BN_Brunei Darussalam' },
                { name: 'Bulgaria', language: 'BG_Bulgaria' },
                { name: 'Myanmar', language: 'MM_Myanmar' },
                { name: 'Burundi', language: 'BI_Burundi' },
                { name: 'Belarus', language: 'BY_Belarus' },
                { name: 'Cambodia', language: 'KH_Cambodia' },
                { name: 'Cameroon', language: 'CM_Cameroon' },
                { name: 'Cape Verde', language: 'CV_Cape Verde' },
                { name: 'Cayman Islands', language: 'KY_Cayman Islands' },
                { name: 'Central African Republic', language: 'CF_Central African Republic' },
                { name: 'Sri Lanka', language: 'LK_Sri Lanka' },
                { name: 'Chad', language: 'TD_Chad' },
                { name: 'Chile', language: 'CL_Chile' },
                { name: 'China', language: 'CN_China' },
                { name: 'Taiwan, Province of China', language: 'TW_Taiwan, Province of China' },
                { name: 'Christmas island', language: 'CX_Christmas island' },
                { name: 'Cocos (Keeling) Islands', language: 'CC_Cocos (Keeling) Islands' },
                { name: 'Colombia', language: 'CO_Colombia' },
                { name: 'Comoros', language: 'KM_Comoros' },
                { name: 'Mayotte', language: 'YT_Mayotte' },
                { name: 'Congo', language: 'CG_Congo' },
                { name: 'Congo, The Democratic Republic of the', language: 'CD_Congo, The Democratic Republic of the' },
                { name: 'Cook Islands', language: 'CK_Cook Islands' },
                { name: 'Costa Rica', language: 'CR_Costa Rica' },
                { name: 'Croatia', language: 'HR_Croatia' },
                { name: 'Cuba', language: 'CU_Cuba' },
                { name: 'Cyprus', language: 'CY_Cyprus' },
                { name: 'Czech Republic', language: 'CZ_Czech Republic' },
                { name: 'Benin', language: 'BJ_Benin' },
                { name: 'Denmark', language: 'DK_Denmark' },
                { name: 'Dominica', language: 'DM_Dominica' },
                { name: 'Dominican Republic', language: 'DO_Dominican Republic' },
                { name: 'Ecuador', language: 'EC_Ecuador' },
                { name: 'El Salvador', language: 'SV_El Salvador' },
                { name: 'Equatorial Guinea', language: 'GQ_Equatorial Guinea' },
                { name: 'Ethiopia', language: 'ET_Ethiopia' },
                { name: 'Eritrea', language: 'ER_Eritrea' },
                { name: 'Estonia', language: 'EE_Estonia' },
                { name: 'Faroe Islands', language: 'FO_Faroe Islands' },
                { name: 'Falkland Islands (Malvinas)', language: 'FK_Falkland Islands (Malvinas)' },
                { name: 'South Georgia and the South Sandwich Islands', language: 'GS_South Georgia and the South Sandwich Islands' },
                { name: 'Fiji', language: 'FJ_Fiji' },
                { name: 'Finland', language: 'FI_Finland' },
                { name: 'Aland Islands', language: 'AX_Aland Islands' },
                { name: 'France', language: 'FR_France' },
                { name: 'French Guiana', language: 'GF_French Guiana' },
                { name: 'French Polynesia', language: 'PF_French Polynesia' },
                { name: 'French Southern Territories', language: 'TF_French Southern Territories' },
                { name: 'Djibouti', language: 'DJ_Djibouti' },
                { name: 'Gabon', language: 'GA_Gabon' },
                { name: 'Georgia', language: 'GE_Georgia' },
                { name: 'Gambia', language: 'GM_Gambia' },
                { name: 'Palestinian Territory, Occupied', language: 'PS_Palestinian Territory, Occupied' },
                { name: 'Ghana', language: 'GH_Ghana' },
                { name: 'Gibraltar', language: 'GI_Gibraltar' },
                { name: 'Kiribati', language: 'KI_Kiribati' },
                { name: 'Greece', language: 'GR_Greece' },
                { name: 'Greenland', language: 'GL_Greenland' },
                { name: 'Grenada', language: 'GD_Grenada' },
                { name: 'Guadeloupe', language: 'GP_Guadeloupe' },
                { name: 'Guam', language: 'GU_Guam' },
                { name: 'Guatemala', language: 'GT_Guatemala' },
                { name: 'Guinea', language: 'GN_Guinea' },
                { name: 'Guyana', language: 'GY_Guyana' },
                { name: 'Haiti', language: 'HT_Haiti' },
                { name: 'Heard Island and McDonald Islands', language: 'HM_Heard Island and McDonald Islands' },
                { name: 'Vatican City State (Holy See)', language: 'VA_Vatican City State (Holy See)' },
                { name: 'HN_Honduras', language: 'HN_Honduras' },
                { name: 'Hong Kong', language: 'HK_Hong Kong' },
                { name: 'Hungary', language: 'HU_Hungary' },
                { name: 'Iceland', language: 'IS_Iceland' },
                { name: 'India', language: 'IN_India' },
                { name: 'Indonesia', language: 'ID_Indonesia' },
                { name: 'Iran, Islamic Republic of', language: 'IR_Iran, Islamic Republic of' },
                { name: 'Iraq', language: 'IQ_Iraq' },
                { name: 'Ireland', language: 'IE_Ireland' },
                { name: 'Israel', language: 'IL_Israel' },
                { name: 'Italy', language: 'IT_Italy' },
                { name: 'Cote D\'Ivoire', language: 'CI_Cote D\'Ivoire' },
                { name: 'Jamaica', language: 'JM_Jamaica' },
                { name: 'Japan', language: 'JP_Japan' },
                { name: 'Kazakhstan', language: 'KZ_Kazakhstan' },
                { name: 'Jordan', language: 'JO_Jordan' },
                { name: 'Kenya', language: 'KE_Kenya' },
                { name: 'Korea, Democratic People\'s Republic of', language: 'KP_Korea, Democratic People\'s Republic of' },
                { name: 'Korea', language: 'KR_Korea' },
                { name: 'Kuwait', language: 'KW_Kuwait' },
                { name: 'Kyrgyzstan', language: 'KG_Kyrgyzstan' },
                { name: 'Lao people\'s democratic republic', language: 'LA_Lao people\'s democratic republic' },
                { name: 'Lebanon', language: 'LB_Lebanon' },
                { name: 'Lesotho', language: 'LS_Lesotho' },
                { name: 'Latvia', language: 'LV_Latvia' },
                { name: 'Liberia', language: 'LR_Liberia' },
                { name: 'Libya', language: 'LY_Libya' },
                { name: 'Liechtenstein', language: 'LI_Liechtenstein' },
                { name: 'Lithuania', language: 'LT_Lithuania' },
                { name: 'Luxembourg', language: 'LU_Luxembourg' },
                { name: 'Macao', language: 'MO_Macao' },
                { name: 'Madagascar', language: 'MG_Madagascar' },
                { name: 'Malawi', language: 'MW_Malawi' },
                { name: 'Malaysia', language: 'MY_Malaysia' },
                { name: 'Maldives', language: 'MV_Maldives' },
                { name: 'Mali', language: 'ML_Mali' },
                { name: 'Malta', language: 'MT_Malta' },
                { name: 'Martinique', language: 'MQ_Martinique' },
                { name: 'Mauritania', language: 'MR_Mauritania' },
                { name: 'Mauritius', language: 'MU_Mauritius' },
                { name: 'Mexico', language: 'MX_Mexico' },
                { name: 'Monaco', language: 'MC_Monaco' },
                { name: 'Mongolia', language: 'MN_Mongolia' },
                { name: 'Moldova', language: 'MD_Moldova' },
                { name: 'Montenegro', language: 'ME_Montenegro' },
                { name: 'Montserrat', language: 'MS_Montserrat' },
                { name: 'Morocco', language: 'MA_Morocco' },
                { name: 'Mozambique', language: 'MZ_Mozambique' },
                { name: 'Oman', language: 'OM_Oman' },
                { name: 'Namibia', language: 'NA_Namibia' },
                { name: 'Nauru', language: 'NR_Nauru' },
                { name: 'Nepal', language: 'NP_Nepal' },
                { name: 'Netherlands', language: 'NL_Netherlands' },
                { name: 'Netherlands Antilles', language: 'AN_Netherlands Antilles' },
                { name: 'Aruba', language: 'AW_Aruba' },
                { name: 'New Caledonia', language: 'NC_New Caledonia' },
                { name: 'Vanuatu', language: 'VU_Vanuatu' },
                { name: 'New Zealand', language: 'NZ_New Zealand' },
                { name: 'Nicaragua', language: 'NI_Nicaragua' },
                { name: 'Niger', language: 'NE_Niger' },
                { name: 'Nigeria', language: 'NG_Nigeria' },
                { name: 'Niue', language: 'NU_Niue' },
                { name: 'Norfolk Island', language: 'NF_Norfolk Island' },
                { name: 'Norway', language: 'NO_Norway' },
                { name: 'Northern Mariana Islands', language: 'MP_Northern Mariana Islands' },
                { name: 'United States Minor Outlying Islands', language: 'UM_United States Minor Outlying Islands' },
                { name: 'Micronesia, Federated States of', language: 'FM_Micronesia, Federated States of' },
                { name: 'Marshall Islands', language: 'MH_Marshall Islands' },
                { name: 'Palau', language: 'PW_Palau' },
                { name: 'Pakistan', language: 'PK_Pakistan' },
                { name: 'Panama', language: 'PA_Panama' },
                { name: 'Papua New Guinea', language: 'PG_Papua New Guinea' },
                { name: 'Paraguay', language: 'PY_Paraguay' },
                { name: 'Peru', language: 'PE_Peru' },
                { name: 'Philippines', language: 'PH_Philippines' },
                { name: 'Pitcairn', language: 'PN_Pitcairn' },
                { name: 'Poland', language: 'PL_Poland' },
                { name: 'Portugal', language: 'PT_Portugal' },
                { name: 'Guinea-bissau', language: 'GW_Guinea-bissau' },
                { name: 'Timor-leste', language: 'TL_Timor-leste' },
                { name: 'Puerto Rico', language: 'PR_Puerto Rico' },
                { name: 'Qatar', language: 'QA_Qatar' },
                { name: 'Reunion', language: 'RE_Reunion' },
                { name: 'Romania', language: 'RO_Romania' },
                { name: 'Russian Federation', language: 'RU_Russian Federation' },
                { name: 'Rwanda', language: 'RW_Rwanda' },
                { name: 'Saint Barthelemy', language: 'BL_Saint Barthelemy' },
                { name: 'Saint Helena', language: 'SH_Saint Helena' },
                { name: 'Saint Kitts and Nevis', language: 'KN_Saint Kitts and Nevis' },
                { name: 'Anguilla', language: 'AI_Anguilla' },
                { name: 'Saint Lucia', language: 'LC_Saint Lucia' },
                { name: 'Saint Martin (French)', language: 'MT_Saint Martin (French)' },
                { name: 'Saint Pierre and Miquelon', language: 'PM_Saint Pierre and Miquelon' },
                { name: 'Saint Vincent and the Grenadines', language: 'VC_Saint Vincent and the Grenadines' },
                { name: 'San Marino', language: 'SM_San Marino' },
                { name: 'Sao Tome and Principe', language: 'ST_Sao Tome and Principe' },
                { name: 'Saudi Arabia', language: 'SA_Saudi Arabia' },
                { name: 'Senegal', language: 'SN_Senegal' },
                { name: 'Serbia', language: 'RS_Serbia' },
                { name: 'Seychelles', language: 'SC_Seychelles' },
                { name: 'Sierra Leone', language: 'SL_Sierra Leone' },
                { name: 'Singapore', language: 'SG_Singapore' },
                { name: 'Slovakia', language: 'SK_Slovakia' },
                { name: 'Vietnam', language: 'VN_Vietnam' },
                { name: 'Slovenia', language: 'SI_Slovenia' },
                { name: 'Somalia', language: 'SO_Somalia' },
                { name: 'South Africa', language: 'ZA_South Africa' },
                { name: 'Zimbabwe', language: 'ZW_Zimbabwe' },
                { name: 'Spain', language: 'ES_Spain' },
                { name: 'Western Sahara', language: 'EH_Western Sahara' },
                { name: 'Sudan', language: 'SD_Sudan' },
                { name: 'Suriname', language: 'SR_Suriname' },
                { name: 'Svalbard and Jan Mayen', language: 'SJ_Svalbard and Jan Mayen' },
                { name: 'Swaziland', language: 'SZ_Swaziland' },
                { name: 'Sweden', language: 'SE_Sweden' },
                { name: 'Switzerland', language: 'CH_Switzerland' },
                { name: 'Syrian Arab Republic', language: 'SY_Syrian Arab Republic' },
                { name: 'Tajikistan', language: 'TJ_Tajikistan' },
                { name: 'Thailand', language: 'TH_Thailand' },
                { name: 'Togo', language: 'TG_Togo' },
                { name: 'Tokelau', language: 'TK_Tokelau' },
                { name: 'Tonga', language: 'TO_Tonga' },
                { name: 'Trinidad and Tobago', language: 'TT_Trinidad and Tobago' },
                { name: 'United Arab Emirates', language: 'AE_United Arab Emirates' },
                { name: 'Tunisia', language: 'TN_Tunisia' },
                { name: 'Turkey', language: 'TR_Turkey' },
                { name: 'Turkmenistan', language: 'TM_Turkmenistan' },
                { name: 'Turks and Caicos Islands', language: 'TC_Turks and Caicos Islands' },
                { name: 'Tuvalu', language: 'TV_Tuvalu' },
                { name: 'Uganda', language: 'UG_Uganda' },
                { name: 'Ukraine', language: 'UA_Ukraine' },
                { name: 'Macedonia, The Former Yugoslav Republic of', language: 'MK_Macedonia, The Former Yugoslav Republic of' },
                { name: 'Egypt', language: 'EG_Egypt' },
                { name: 'Guernsey', language: 'GG_Guernsey' },
                { name: 'Jersey', language: 'JE_Jersey' },
                { name: 'Isle of man', language: 'IM_Isle of man' },
                { name: 'Tanzania, United Republic of', language: 'TZ_Tanzania, United Republic of' },
                { name: 'Virgin islands (U.S.)', language: 'VI_Virgin islands (U.S.)' },
                { name: 'Burkina Faso', language: 'BF_Burkina Faso' },
                { name: 'Uruguay', language: 'UY_Uruguay' },
                { name: 'Uzbekistan', language: 'UZ_Uzbekistan' },
                { name: 'Venezuela', language: 'VE_Venezuela' },
                { name: 'Wallis and Futuna', language: 'WF_Wallis and Futuna' },
                { name: 'Samoa', language: 'WS_Samoa' },
                { name: 'Yemen', language: 'YE_Yemen' },
                { name: 'Yugoslavia', language: 'YU_Yugoslavia' },
                { name: 'Zambia', language: 'ZM_Zambia' },
                { name: 'Kosovo', language: 'KV_Kosovo' },
                { name: 'South Sudan', language: 'SS_South Sudan' },
                { name: 'Channel Islands', language: '0_Channel Islands' },
                { name: 'Azores', language: '0_Azores' },
                { name: 'Diego Garcia', language: '0_Diego Garcia' },
                { name: 'Ivory Coast', language: 'IC_Ivory Coast' },
                { name: 'Curaçao', language: 'CW_Curaçao' }
            ]          
        };        
    },
    components:{
        VueTelInput,  
        Multiselect,
        VueHcaptcha 
    },
    mounted :function(){
        this.getlangVar();
        this.getUCMSCompList();
        this.currentDate();
        this.checkDateFormat();
        //this.getUCMSServiceList();
    },
    created:function(){
    },
    watch: {
        company: function() {
            this.validateFormRemoveMarkers('company_validation_error');               
        },
        fname: function() {
            this.validateFormRemoveMarkers('fname_validation_error');               
        },
        lname: function() {
            this.validateFormRemoveMarkers('lname_validation_error');               
        },
        dob: function() {
            this.validateFormRemoveMarkers('dob_validation_error');               
        },
        phone: function() {
            this.validateFormRemoveMarkers('phone_validation_error');               
        },        
        country: function() {
            this.validateFormRemoveMarkers('country_validation_error');               
        },
        hemail: function() {
            this.validateFormRemoveMarkers('hemail_validation_error');               
        },        
        message: function() {
            this.validateFormRemoveMarkers('message_validation_error');               
        },        
        fterms: function() {
            this.validateFormRemoveMarkers('fterms_validation_error');               
        },
        bestTime: function(){
            this.validateFormRemoveMarkers('bestTime_validation_error');
        },
        gender: function(){
            this.validateFormRemoveMarkers('gender_validation_error');
        },
        verified: function() {
            this.validateFormRemoveMarkers('hccaptcha_validation_error');               
        }
    },
	methods:{
        checkDateFormat(){
            var id_country = this.$store.state.companyData['id_country'];
            var length = this.europeanCountryAry.length;
            for(var i = 0; i < length; i++) {
                if(this.europeanCountryAry[i] == id_country){
                    this.defaultDateFormat = 'DD/MM/YYYY';
                }
            }
        },
        currentDate() {
            const current = new Date();
            var current_month = current.getMonth()+1;
            if(current_month.length != '2'){
                current_month = '0'+current_month;
            }
            const date = `${current.getFullYear()}-${current_month}-${current.getDate()}`;
            this.todayDate = date;
        },
        emitToTelinput(phoneText, phoneObject) { 
            //this.$emit('telinput', phoneText, phoneObject); 
            //console.log(phoneText+' - '+phoneObject.number);
            this.phonenumwithcode = phoneObject.number;
        },
        validateTel() {
            var phoneCheck = this.phonenumwithcode;
            //phoneCheck = phoneCheck.replace(/-/g,'');
			//phoneCheck = phoneCheck.replace(/ /g,'');
            var regex = /^\+(?:[0-9]●?){6,14}[0-9]$/;
            if (!regex.test(phoneCheck)) {
                this.validateFormAddMarkers('phone_validation_error','dynamic_form_error_required','Invalid phone number');  
                this.$refs.phone.focus(); 
                $('#phone_validation_error').attr('aria-label','Invalid phone number');
                return false;
            }
            return true;
        },
        sendForm(){            
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                   
                }
            }
            const formData = new FormData()
            formData.append('company', this.company)
            formData.append('fname', this.fname)
            formData.append('lname', this.lname)
            formData.append('dob', this.dob)
            formData.append('gender', this.gender)
            formData.append('fulhomephone', this.phonenumwithcode)
            formData.append('hemail', this.hemail)
            formData.append('country', this.country.language)
            formData.append('bestTime', this.bestTime)
            formData.append('message', this.message)
            formData.append('terms', this.fterms)
            formData.append('id_company', this.$store.state.companyData['id_company'])
            formData.append('id_language', this.$store.state.companyData['id_language'])
            formData.append('name_company', this.$store.state.companyData['name_company'])
            formData.append('id_eap', this.$store.state.companyData['id_eap'])
            formData.append('id_country', this.$store.state.companyData['id_country'])
            formData.append('name_eap', this.$store.state.companyDataInfo['name_eap'])
            formData.append('hc_token', this.token)

            if(!this.validateTel()){
                return false;
            }
            
           var validateForm = this.validateForm(undefined,this.phone,undefined,this.country.language,undefined,undefined,this.message,undefined,this.fterms,undefined,this.company,this.fname,this.lname,this.dob,this.hemail,this.bestTime,this.gender,this.verified);           
           if(!validateForm){
                this.disablefdbtn=true;
                document.getElementById('subButton').style.display = 'none'                     
                axios.post(this.$store.state.FORM_ACTION_DOMAIN+'/new_eesite_forms/contact_counselor_form_new.php',formData,config)
                .then(response => {                    
                    //console.log('forreturn-',response)
                    if(response === undefined || response.length == 0 ){
                        this.returnmsg='! Something went wrong, Please try again'
                    }
                    else{
                        this.returnmsg = response.data
                    }                    
                })
                .catch(() => {                    
                    this.returnmsg='Try after sometime'
                });
            }
        },
        async getlangVar(){
            var api_private_key=this.get_api_key_mix('lams')
            await axios.get(this.$store.state.apiUrl+'/language_terms',{
                params:{
                    id_language:this.$store.state.companyData['id_language'],
                    privatekey:api_private_key,
                    id_company:this.$store.state.companyData['id_company'],
                    id_country:this.$store.state.companyData['id_country']                  
                }
            })
            .then(response => {              
                response = response.data
                
                this.lang_detail = response
                this.terms_check = this.lang_detail['terms_check'].replace("<br />", " ");
                this.companyLabel =  this.lang_detail['Company'].replace("*", ""); 
                this.reasonListAry['1'] = 'cc_childcare'//this.lang_detail['cc_childcare'];          
                this.reasonListAry['2'] = 'cc_eldercare'//this.lang_detail['cc_eldercare'];
                this.reasonListAry['3'] = 'cc_convenience'//this.lang_detail['cc_convenience'];
                this.reasonListAry['4'] = 'cc_legal'//this.lang_detail['cc_legal'];
                this.reasonListAry['5'] = 'cc_financial'//this.lang_detail['cc_financial'];
                this.reasonListAry['6'] = 'cc_call'//this.lang_detail['cc_call'];
                this.reasonListAry['7'] = 'cc_lifecoach'//this.lang_detail['cc_lifecoach'];
                this.reasonListAry['8'] = 'cc_wellcoach'//this.lang_detail['cc_wellcoach'];
                this.reasonListAry['9'] = 'cc_tobaccocoach'//this.lang_detail['cc_tobaccocoach'];
                this.gender=this.lang_detail['undisclosed'];
                this.getUCMSServiceList();
            })
            .catch(() => {
                this.main_content = []
            });
        },
        async getUCMSCompList(){ 
            await this.getCompanyInfo(); 
            axios.get(UCMS_API_URL+'/api/client/company',{
                params:{
                    CompanyId:this.comp_detail.ucms_company  //'221236'//              
                },
                headers: {
                    'Content-Type':'application/json',
                    'Authorization':UCMS_AUTHORIZATION,
                    '_WPOSUBSCRIBER':UCMS_WPOSUBSCRIBER                   
                }
            })
            .then(response => {              
                response = response.data
                this.comp_list = response
                if(Object.keys(this.comp_list).length == 1) {
                    this.shwcompany = this.comp_list[Object.keys(this.comp_list)[0]];
                    this.company = Object.keys(this.comp_list)[0]+'_'+this.comp_list[Object.keys(this.comp_list)[0]];
                    document.getElementById('shwcompany').setAttribute('readonly', true);
                } else {
                    this.shwcompany = '';
                    this.company = '0_Unknown Company';
                }             
            })
            .catch(() => {
                this.comp_list = []
            });
        },
        getUCMSServiceList(){
            axios.get(UCMS_API_URL+'/api/client/service',{
                params:{                  
                },
                headers: {
                    'Content-Type':'application/json',
                    'Authorization': UCMS_AUTHORIZATION,
                    '_WPOSUBSCRIBER':UCMS_WPOSUBSCRIBER                   
                }
            })
            .then(response => {  
                let newAry = []            
                response = response.data
                this.service_list = response 
                for(var i=1;i<=9;i++){ //Object.keys(this.service_list).length
                    newAry[i+'_'+this.service_list[i]] = this.lang_detail[this.reasonListAry[i]];
                }  
                this.service_list = Object.assign({}, newAry); //convert array to object
            })
            .catch(() => {
                this.service_list = []
            });
        },
        async getCompanyInfo(){
            var api_private_key=this.get_api_key_mix('cofo')
            await axios.get(this.$store.state.apiUrl+'/company_info',{
                params:{
                    id_language:this.$store.state.companyData['id_language'],
                    privatekey:api_private_key,
                    id_country:this.$store.state.companyData['id_country'],  
                    id_company:this.$store.state.companyData['id_company']                 
                }
            })
            .then(response => {              
                response = response.data
                this.comp_detail = response              
            })
            .catch(() => {
                this.comp_detail = []
            });
        },
        myFunction() {
            // Declare variables
            var input, filter, ul, li, a, i, txtValue, shwCnt=0;
            input = document.getElementById('shwcompany');
            filter = input.value.toUpperCase();
            ul = document.getElementById("myUL");
            li = ul.getElementsByTagName('li');
            ul.style.display = "";
            //document.getElementById('company').value = '';
            this.company = '';
            document.getElementById("err").style.display = "none";
            
            // Loop through all list items, and hide those who don't match the search query
            for (i = 0; i < li.length; i++) {
            a = li[i].getElementsByTagName("a")[0];
            txtValue = a.textContent || a.innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                li[i].style.display = "";
                shwCnt += 1;
            } else {
                li[i].style.display = "none";
            }
            }
            
            if(shwCnt == 0){
                ul.style.display = "none";
                document.getElementById("err").style.display = "";
            }
            if(filter == ''){
                ul.style.display = "none";
                document.getElementById("err").style.display = "none";
            }
        },        
        filCompValue(val){
            var ul, vl;
            ul = document.getElementById("myUL");
            ul.style.display = "none";
            vl = val.split('_');
            document.getElementById('shwcompany').value = vl[1];
            //document.getElementById('company').value = val;
            this.company = val;				
        },
        setDate(){ 
            if(this.dob != ''){
				document.getElementById("dob").setAttribute(
					"data-date",
					moment(this.dob, "YYYY-MM-DD").format( this.defaultDateFormat )
				)
			}
        },
        onVerify(token, ekey) {
            this.verified = true;
            this.token = token;
            this.eKey = ekey;
        },
        onExpire() {
            this.verified = false;
            this.token = null;
            this.eKey = null;
            this.expired = true;
            //console.log('hcExpired');
        },
        onError(err) {
            this.token = null;
            this.eKey = null;
            this.error = err;
            //console.log(`hcError: ${err}`);
        }
    }
};
</script>
<style scoped>
.form-group{
    margin-bottom: 40px;
}
.side{
   margin-left:15px; 
}

.side .submit{
    right: 20px !important;
}
@media screen and (max-width: 350px) {
    .side{
        margin-left:18px; 
    }
    .side .submit{
        right: 30px !important;
    }
}

.dynamic_form_error_required{
    padding-left:15px !important;
    color:#FF0000 !important;    
}
.required_indicator {
    font-family: Verdana;
    font-size: 14px;
    color: red;
}
.form-control {
    -webkit-appearance: auto;
    -moz-appearance: auto;
    appearance: auto;
}
</style>
<style>
.vti__dropdown-list{
  width:700px !important;
}
.vue-tel-input{
    height: 54px !important;
}

#myUL {
    /* Remove default list styling */
    list-style-type: none;
    padding: 0;
    margin: 0;
}

#myUL li a {
    border: 1px solid #ddd; /* Add a border to all links */
    margin-top: -1px; /* Prevent double borders */
    background-color: #f6f6f6; /* Grey background color */
    padding: 12px; /* Add some padding */
    text-decoration: none; /* Remove default text underline */
    font-size: 18px; /* Increase the font-size */
    color: black; /* Add a black text color */
    display: block; /* Make it into a block element to fill the whole list */
}

#myUL li a:hover:not(.header) {
    background-color: #eee; /* Add a hover effect to all links, except for headers */
}

#err {
    /* Remove default list styling */
    list-style-type: none;
    padding: 0;
    margin: 0;
}

#err li {
    /*border: 1px solid #ddd; /* Add a border to all links */
    margin-top: -1px; /* Prevent double borders */
    /*background-color: #f6f6f6; /* Grey background color */
    padding: 10px; /* Add some padding */
    text-decoration: none; /* Remove default text underline */
    font-size: 14px; /* Increase the font-size */
    color: red; /* Add a black text color */
    display: block; /* Make it into a block element to fill the whole list */
}

#dob {
    position: relative;
    width: 100%; height: 54px;
    color: white;
}
#dob:before {
    position: absolute;
    content: attr(data-date);
    display: inline-block;
    color: black;
}
#dob::-webkit-datetime-edit, input::-webkit-inner-spin-button, input::-webkit-clear-button {
    display: none;
}
#dob::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 12px;
    right: 0;
    color: black;
    opacity: 1;
}
.multiselect__tags{
    height: 54px;
}
.hhcap{
    padding-left: 1em;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>